import React, { useState, useEffect, useContext } from 'react';
import { Card, Row, Col, Badge, Spinner, Alert, Container, Button } from 'react-bootstrap';
import {
    FaCalendarAlt,
    FaMoneyBillWave,
    FaSync,
    FaClock,
    FaCheckCircle,
    FaExclamationTriangle,
    FaCalendarCheck,
    FaCalendarTimes,
    FaCog,
    FaArrowLeft,
    FaDownload,
    FaEdit,
    FaChartLine,
    FaReceipt,
    FaUserClock,
    FaDatabase,
    FaMandalorian
} from 'react-icons/fa';
import moment from 'moment';
import Swal from 'sweetalert2';
import Header from './Header';
import { Link, useLocation } from 'react-router-dom';
import { all_routes } from './router/all_routes';
import Icon from '@ant-design/icons/lib/components/Icon';
import { Icon0Circle } from 'react-bootstrap-icons';
import { ProductContext } from '../context/AppContext';

const ChapterDetails = () => {
    const [feeCycleData, setFeeCycleData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const { clsSecId, GetstudentData } = useContext(ProductContext);
    const [openChapterId, setOpenChapterId] = useState(null);
    const [resultsByChapter, setResultsByChapter] = useState({});

      const location = useLocation();
      const paperId = location.state?.paperId;
      const PaperName = location.state?.PaperName;

      const StudentId = GetstudentData?.id;


  console.log(StudentId, "StudentId 1500");


    const authtoken = localStorage.getItem("token");


    const [papers, setPapers] = useState([]);
    const [loadingPapers, setLoadingPapers] = useState(false);
    const [papersResult, setPapersResult] = useState([]);

    const fetchSubjectPapers = async () => {
        try {
            setLoadingPapers(true);
            const token = localStorage.getItem("token");

            const studentQuery = StudentId ? `student_id=${StudentId}&` : '';
            const res = await fetch(
                `https://api.mirai.healthcare/api/paper/chapter-test?${studentQuery}cls_sec_id=${clsSecId}&paper_id=${paperId}`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "x-auth": authtoken,
                    },
                }
            );

            const result = await res.json();

            if (result.success) {
                setPapers(result?.message);
            }
        } catch (err) {
            console.error("Error fetching papers", err);
        } finally {
            setLoadingPapers(false);
        }
    };

    useEffect(() => {
       fetchSubjectPapers();
    }, []);

    
    //   const fetchSubjectPapersResult = async (chapterId) => {
    //     try {
    //       setLoadingPapers(true);
    
    //       const authtoken = localStorage.getItem("token");
    
    //       const res = await fetch(
    //         `https://api.mirai.healthcare/api/paper/chapter-test-result?student_id=${StudentId}&paper_id=${paperId}&chapter_id=${chapterId}`,
    //         // `https://api.mirai.healthcare/api/paper/chapter-test-result?student_id=85&paper_id=1&chapter_id=1`,
    //         {
    //           method: "GET",
    //           headers: {
    //             Accept: "application/json",
    //             "Content-Type": "application/json",
    //             "x-auth": authtoken,
    //           },
    //         }
    //       );
    
    //       const result = await res.json();
    
    //       if (result.success) {
    //         setPapersResult(result.message);
    //       }
    //     } catch (err) {
    //       console.error("Error fetching papers result", err);
    //     } finally {
    //       setLoadingPapers(false);
    //     }
    //   };
    
      // 🔥 IMPORTANT: call the function
     
      const fetchSubjectPapersResult = async (chapterId) => {
  try {
    setLoadingPapers(true);

    const res = await fetch(
      `https://api.mirai.healthcare/api/paper/chapter-test-result?student_id=${StudentId}&paper_id=${paperId}&chapter_id=${chapterId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth": authtoken,
        },
      }
    );

    const result = await res.json();

    if (result.success) {
      setResultsByChapter((prev) => ({
        ...prev,
        [chapterId]: result.message,
      }));
    }
  } catch (err) {
    console.error("Error fetching papers result", err);
  } finally {
    setLoadingPapers(false);
  }
};


const handleToggle = (chapterId) => {
  // hide if same chapter clicked
  if (openChapterId === chapterId) {
    setOpenChapterId(null);
    return;
  }

  setOpenChapterId(chapterId);

  // fetch only if not loaded yet
  if (!resultsByChapter[chapterId]) {
    fetchSubjectPapersResult(chapterId);
  }
};


    console.log(papersResult, "papersResult details");


const capitalizeFirstLetter = (text = "") => text.charAt(0).toUpperCase() + text.slice(1);



    return (
        <div className="page-wrapper">
            <div className="content">
                <Header />

                <Container fluid className="py-4">
                    {/* Modern Header */}


                    {/* Main Content */}
                    <Row className="g-4">
                        {/* Left Column - Details */}
                        <Col lg={12}>
                            <Card className="modern-card border-0">
                                <Card.Header className="modern-card-header">
                                    <h2 className="page-title fw-bold mb-0">{capitalizeFirstLetter(PaperName)}</h2>
                                </Card.Header>
                                <Card.Body className="p-0">

  {papers?.map((item) => (
    <div
      key={item.id}
      className="info-item d-flex align-items-start p-3 border-bottom"
    >
      <div className="flex-grow-1">

        {/* Title */}
        <Col lg={12}>
          <h5 className="fw-bold text-dark mb-0">
            {capitalizeFirstLetter(item?.chapter?.name)}
          </h5>
        </Col>

        {/* Description */}
        <Col lg={12}>
          {item?.chapter?.description && (
            <p className="text-muted mb-1 mt-1 line-clamp-2">
              Description: {capitalizeFirstLetter(item?.chapter?.description)}
            </p>
          )}
        </Col>
        {!item?.chapter?.complete_date && (
  <Button variant="warning">Pending</Button>
)}

        
              {item?.chapter?.complete_date && (
                <div className="h-100">
                    <Row>
                    <Col md={6}>
                  <p className="text-muted mb-1 fw-semibold">Complete Date</p>
                  <p className="mb-0 text-green fw-bold">
                    {moment(item.chapter.complete_date).format("DD-MM-YYYY")}
                  </p>
                  </Col>
                  <Col md={6} className='text-end mt-1'>
                  <Button onClick={() => handleToggle(item.chapter.id)}>
  {openChapterId === item.chapter.id ? "Hide Result" : "View Result"}
</Button>
                  </Col>
                  </Row>
                </div>
              )}

        {/* 🔽 RESULTS LIST (mapped) */}
        {openChapterId === item.chapter.id &&
  resultsByChapter[item.chapter.id]?.map((res, index) => (
          <Row key={index} className="g-3 align-items-center mt-0">

           <Col md={12}>
        <h6 className="fw-bold mb-0">
          Result {index + 1}
        </h6>
      </Col>
            <Col md={4}>
              <div className="p-3 border text-center rounded bg-light h-100">
                <p className="text-muted mb-1 fw-semibold new_cass_1">Min Marks</p>
                <p className="mb-0 new_cass_2">{res?.min_marks ?? "-"}</p>
              </div>
            </Col>

            {/* Max Marks */}
            <Col md={4}>
              <div className="p-3 border text-center rounded bg-light h-100">
                <p className="text-muted mb-1 fw-semibold new_cass_1">Max Marks</p>
                <p className="mb-0 new_cass_2">{res?.max_marks ?? "-"}</p>
              </div>
            </Col>

            {/* Result Date */}
            <Col md={4}>
              <div className="p-3 border text-center rounded bg-light h-100">
                <p className="text-muted mb-1 fw-semibold new_cass_1">Result Date</p>
                <p className="mb-0 new_cass_2">
                  {res?.date
                    ? moment(res.date).format("DD-MM-YYYY")
                    : "-"}
                </p>
              </div>
            </Col>

          </Row>
        ))}

      </div>
    </div>
  ))}

</Card.Body>


                            </Card>
                        </Col>


                    </Row>
                </Container>

                <style jsx>{`
          .page-header-modern {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem;
            border-radius: 20px;
            margin-top: 1rem;
          }

          .modern-breadcrumb {
            background: transparent;
            padding: 0;
            margin-bottom: 1rem;
          }

          .modern-breadcrumb .breadcrumb-item a {
            color: rgba(255,255,255,0.8) !important;
            text-decoration: none;
          }

          .modern-breadcrumb .breadcrumb-item.active {
            color: white !important;
          }

          .page-title-modern {
            font-size: 2.5rem;
            font-weight: 700;
            margin: 0;
            color: white;
          }

          .header-icon {
            background: rgba(255,255,255,0.2);
            padding: 1rem;
            border-radius: 15px;
            backdrop-filter: blur(10px);
          }

          .btn-modern {
            border-radius: 10px;
            padding: 0.75rem 1.5rem;
            font-weight: 600;
            border: none;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
            transition: all 0.3s ease;
          }

          .btn-modern:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0,0,0,0.15);
          }

          .progress-section {
            background: rgba(255,255,255,0.1);
            padding: 1.5rem;
            border-radius: 15px;
            backdrop-filter: blur(10px);
          }

          .modern-progress {
            height: 8px;
            border-radius: 10px;
            background: rgba(255,255,255,0.2);
          }

          .modern-progress .progress-bar {
            background: linear-gradient(90deg, #00b09b, #96c93d);
            border-radius: 10px;
            transition: width 0.5s ease;
          }

          .modern-card {
            border-radius: 15px;
            box-shadow: 0 5px 25px rgba(0,0,0,0.08);
            overflow: hidden;
            transition: all 0.3s ease;
          }

          .modern-card:hover {
            box-shadow: 0 8px 30px rgba(0,0,0,0.12);
          }

          .modern-card-header {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-bottom: 1px solid #e9ecef;
            padding: 1.5rem;
          }

          .stat-card {
            border-radius: 15px;
            transition: all 0.3s ease;
            background: white;
            box-shadow: 0 5px 20px rgba(0,0,0,0.08);
          }

          .stat-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 30px rgba(0,0,0,0.15);
          }

          .icon-container {
            width: 50px;
            height: 50px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
          }

          .info-item {
            transition: all 0.3s ease;
            border-bottom: 1px solid #f8f9fa;
          }

          .info-item:hover {
            background: #f8f9fa;
            transform: translateX(5px);
          }

          .info-item:last-child {
            border-bottom: none;
          }

          .timeline {
            position: relative;
            padding-left: 2rem;
          }

          .timeline::before {
            content: '';
            position: absolute;
            left: 15px;
            top: 0;
            bottom: 0;
            width: 2px;
            background: #e9ecef;
          }

          .timeline-item {
            position: relative;
            margin-bottom: 2rem;
          }

          .timeline-marker {
            position: absolute;
            left: -2rem;
            top: 0.25rem;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 3px solid white;
            box-shadow: 0 0 0 3px;
          }

          .loading-spinner {
            max-width: 400px;
            margin: 0 auto;
          }

          .error-state {
            max-width: 500px;
            margin: 0 auto;
          }

          .coming-soon-popup {
            border-radius: 15px;
          }

          @media (max-width: 768px) {
            .page-header-modern {
              padding: 1.5rem;
              margin-top: 0.5rem;
            }

            .page-title-modern {
              font-size: 2rem;
            }

            .d-flex.gap-3 {
              flex-direction: column;
              align-items: flex-start;
            }

            .header-icon {
              margin-bottom: 1rem;
            }

            .d-flex.gap-2 {
              flex-wrap: wrap;
            }

            .btn-modern {
              margin-bottom: 0.5rem;
            }
          }
        `}</style>
            </div>
        </div>
    );
};

export default ChapterDetails